import type { AffiliateProduct, AffiliateProductDTO } from '@/modules/pmt/interfaces';

export const mapAffiliateProducts = (products: AffiliateProductDTO[]): AffiliateProduct[] => {
  return products.map((item) => {
    return {
      id: item.id,
      asin: item.asin,
      title: item.title,
      originalPrice: item.original_price,
      afterDiscountPrice: item.after_discount_price,
      imageUrls: item.image_urls,
      badge: item.badge,
      affiliateUrl: item.affiliate_url,
      category: item.category,
      locale: item.locale,
      mainCategory: item.main_category,
    } as AffiliateProduct;
  });
};
